import React from 'react'
import { Map, List } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../../actions/index'
import Sherpa from '../../Sherpa/index'
import DetailPageV3CourseModule from './DetailPageV3CourseModule'

/**
 * @param {Object} props - The props
 * @param {Map} props.modulesData - The course modules data
 * @param {Map} props.progressData - The course progress data
 * @param {number} props.courseContentId - The course content ID
 * @param {function} props.onCourseStateChange - The function to handle course state change
 * @returns {JSX.Element} DetailPageV3CourseModules
 */

const DetailPageV3CourseModules = (props) => {
  const {
    modulesData = List(),
    courseContentId,
    onCourseStateChange,
  } = props

  if (!modulesData.size) {
    return (
      <div className="detail-page-v3">
        <div className="detail-page-v3__loading">
          <Sherpa />
        </div>
      </div>
    )
  }

  return (
    <div className="detail-page-v3__course-modules" id="courseModules">
      {modulesData.map((moduleData, index) => {
        return <DetailPageV3CourseModule
          key={moduleData.get('id') || index}
          moduleData={moduleData}
          moduleNumber={index + 1}
          courseContentId={courseContentId}
          onCourseStateChange={onCourseStateChange}
        />
      })}
    </div>
  )
}

export default connectRedux((state) => ({
  staticText: state.staticText.getIn(['data', 'detailPageV3', 'data'], Map()),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    setEventDefault: actions.eventTracking.setEventDefault,
  }
})(DetailPageV3CourseModules)
